import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Modal, TextInput, Label } from "flowbite-react";
import Head_data from "../components/Head_data";
import GlobalContext from "../connections/GlobalContext";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEye, FaTrash, FaPrint, FaCheckCircle } from "react-icons/fa";
import { FaStickyNote } from "react-icons/fa";
import EstimateDetailsTable from "./EstimateDetailsTable";
import Service_details from "./Service_details";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import image from "./logo.png";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Calendar as CalendarIcon } from "lucide-react";
import engineGif from "../image/engine.gif";
import Logo from "../image/logo.jpg";
import html2pdf from "html2pdf.js";



const Service_log = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [add_show, setAdd_show] = useState(false);
  const [flag_branch, setFlag_branch] = useState(
    sessionStorage.getItem("branch")
  );
  const [flag_berror, setFlag_berror] = useState("");
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const { globalValue } = useContext(GlobalContext);
  const [dis, setDis] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openCard, setOpenCard] = useState(false);
  const [temp_brand_modal, setTemp_brand_modal] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(data);
  const [bill_type, setBill_type] = useState("");
  const [totalDiscount1, setTotalDiscount] = useState(0);
  const [flag, setFlag] = useState("");

  // ─── Remark Modal State ───────────────────────────────────────────────────
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [remarkRowId, setRemarkRowId] = useState(null);
  const [remark, setRemark] = useState("");
  const [debouncedRemark, setDebouncedRemark] = useState("");
  const [remarkSaving, setRemarkSaving] = useState(false);
  const [remarkSaved, setRemarkSaved] = useState(false);
  // ─────────────────────────────────────────────────────────────────────────

  // ─── PDF Remark State ─────────────────────────────────────────────────────
  const [pdfRemark, setPdfRemark] = useState("");
  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const filteredData = data.filter(
      (branch) =>
        branch["customer_name"]
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        branch["vehicle_no"]
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        branch["brand"]?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        branch["model"]?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, data]);

  const handlePrint = () => {
    const content = document.getElementById("pdf-content");

    html2canvas(content, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const pageHeight = pdf.internal.pageSize.getHeight();

      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
      position -= pageHeight;

      while (Math.abs(position) < pdfHeight) {
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
        position -= pageHeight;
      }

      pdf.save("receipt.pdf");
      setDis(true);
    });
  };

  const handlePrint1 = () => {
    const element = document.getElementById("pdf-content");

    const options = {
      margin: [5, 5, 5, 5],
      filename: "receipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "p" },
      pagebreak: { mode: ['css', 'legacy'] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .save();
  };

  const fetchData = () => {
    setLoading(true);
    fetch(globalValue + "/customers", {
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const formattedData = data.map((item) => ({
          value: item[1],
          label: item[2],
        }));
        setCustomers(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => setLoading(false));
  };

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/service_log_display`, {
        params: {
          data: flag_branch,
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setData(response.data);
      console.log(response.data);
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setLoading(false);
    }
  };

  const [first, setFirst] = useState(false);

  const [branches, setBranches] = useState([]);
  const fetchData1 = () => {
    setLoading(true);
    fetch(globalValue + "/branches", {
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((dat) => {
        setBranches(dat);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => setLoading(false));
  };

  const [spares, setSpares] = useState([]);
  const fetchData2 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${globalValue}/spares`,
        {
          params: {
            data: sessionStorage.getItem("branch"),
            position: "",
          },
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setSpares(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDetails();
    fetchData1();
    fetchData2();
    fetchDetails();
  }, []);

  const handleSave = async () => {
    if (selectedCustomer && date) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${globalValue}/estimate_cust`,
          {
            customer: selectedCustomer.value,
            date,
          },
          {
            headers: {
              "x-access-token": sessionStorage.getItem("token"),
            },
          }
        );
        if (response.data === "success") {
          setModalOpen(false);
          Swal.fire({
            icon: "success",
            title: "Customer Added Successfully",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      alert("Please select a customer and enter a date.");
    }
  };
  const [show, setShow] = useState(false);
  const [est_is, setEst_id] = useState("");
  const [view_data, setView_data] = useState([]);

  const [add_data, setAdd_data] = useState([]);
  const add_details = async (link) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/add_details_service`,
        {
          link,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      console.log(response.data);
      setAdd_data(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const view_details = async (est_is) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/view_service`,
        {
          est_is,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      console.log(response.data);
      setView_data(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const [complete_records, setCompleteRecords] = useState([])

  const service_complete_records = async (link) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/get_service_details`,
        {
          link_id: link,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setCompleteRecords(response.data.data);

      navigate('/complete_service', {
        state: { link: link, estimate_id: est_is }
      })


    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const [swap, setSwap] = useState(true);
  const [swap1, setSwap1] = useState(true);
  const navigate = useNavigate();

  const spare_name = (id) => {
    let name = "";
    for (let i = 0; i < spares.length; i++) {
      if (spares[i][1] === id) {
        name = spares[i][2];
      }
    }
    return name;
  };

  const [pdfpopup, setPdfpopup] = useState(false);
  const [isPdfFormate, setIsPdfFormate] = useState(false);
  const [pdf_data, setPdf_data] = useState([]);
  const [pdf_insurance_data, setPdf_insurance_data] = useState([]);

  const makePdf = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/pdf1`,
        {
          id: data["estimate_id"],
          branch: sessionStorage.getItem("branch"),
          mode: data["mode"],
          link: data["link"],
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      setPdf_data(response.data);
      console.log(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
    setPdfpopup(true);
  };

  // ─── makePdf1: fetch receipt data + remark together ──────────────────────
  const makePdf1 = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/pdf1`,
        {
          id: data["estimate_id"],
          branch: sessionStorage.getItem("branch"),
          mode: data["mode"],
          link: data["link"],
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      setPdf_insurance_data(response.data);
      console.log(response.data);

      // ─── Fetch remark for this service log entry ───────────────────────
      try {
        const remarkRes = await axios.get(`${globalValue}/get_remark`, {
          params: { table: "service_log", id: data["estimate_id"] },
          headers: { "x-access-token": sessionStorage.getItem("token") },
        });
        setPdfRemark(
          remarkRes.data.success === 1 ? remarkRes.data.remark || "" : ""
        );
      } catch {
        setPdfRemark("");
      }
      // ──────────────────────────────────────────────────────────────────

    } catch (error) {
    } finally {
      setLoading(false);
    }
    setIsPdfFormate(true);
  };
  // ─────────────────────────────────────────────────────────────────────────

  const get_grand_total = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/pdf1`,
        {
          id: data["estimate_id"],
          branch: sessionStorage.getItem("branch"),
          mode: data["mode"],
          link: data["link"],
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      setPdf_data(response.data);
      console.log(response.data);
      return response.data.overall_grand_total;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const complete = async (
    id,
    link,
    customer_id,
    status,
    paymentType,
    paymentDate,
    grand_total
  ) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/service_complete`,
        {
          id,
          link,
          customer_id,
          status,
          paymentType,
          paymentDate,
          grand_total,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        Swal.fire({
          icon: "success",
          title: "Service Completed Successfully",
        });
        fetchDetails();
      } else if (response.data === "pending") {
        Swal.fire({
          icon: "warning",
          title: "Error",
          text: "There are some pending estimates",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Service completion failed. Please try again!",
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const delete_estimate = async (id, link, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you won't be able to recover this estimate!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(
            `${globalValue}/delete_service`,
            { id, link, status },
            {
              headers: {
                "x-access-token": sessionStorage.getItem("token"),
              },
            }
          );

          console.log(response);

          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Estimate deleted successfully",
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "Estimate not deleted successfully",
            });
          }

          fetchData();
          fetchData2();
          fetchData1();
          fetchDetails();
        } catch (error) {
          console.error("Error deleting estimate:", error);
          Swal.fire({
            icon: "error",
            title: "Error deleting estimate",
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const [check_data, setCheck_date] = useState([]);
  const [showChecked, setShowChecked] = useState(false);

  const check_spares = async (link, customer_id) => {
    try {
      const response = await axios.post(`${globalValue}/check_spares_data`, {
        link, customer_id
      })
      setCheck_date(response.data);
    } catch (error) {
    }
  }

  function groupSparesByGst(all_spares) {
    const gstGroups = {};
    all_spares.forEach(spare => {
      const gst = spare.gst;
      if (!gstGroups[gst]) gstGroups[gst] = [];
      gstGroups[gst].push(spare);
    });
    return gstGroups;
  }

  function getLabourSummary(pdf_data) {
    return (pdf_data.services || []).map(service => {
      const category = (pdf_data.service_category || []).find(
        c => String(c.service_name).trim().toLowerCase() === String(service.service_name).trim().toLowerCase()
      );
      const subcategoriesTotal =
        category && category.subcategories
          ? category.subcategories.reduce((sum, sub) => sum + Number(sub.amount || 0), 0)
          : 0;

      const showLabour = (!category || !category.subcategories || category.subcategories.length === 0);

      return {
        service_name: service.service_name,
        labour_charge: showLabour ? Number(service.labour_charge || 0) : subcategoriesTotal,
        has_subcategories: !showLabour,
        subcategories: category ? category.subcategories : []
      };
    });
  }

  const gstGrouped = groupSparesByGst(pdf_data.all_spares || []);
  const labourSummary = getLabourSummary(pdf_data);

  // ─── Remark: Open modal & fetch existing remark ───────────────────────────
  const handleOpenRemark = async (estimateId) => {
    setRemarkRowId(estimateId);
    setRemark("");
    setDebouncedRemark("");
    setRemarkSaved(false);
    setRemarkModalOpen(true);

    try {
      const response = await axios.get(`${globalValue}/get_remark`, {
        params: { table: "service_log", id: estimateId },
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });
      if (response.data.success === 1) {
        setRemark(response.data.remark || "");
        setDebouncedRemark(response.data.remark || "");
      }
    } catch (error) {
      console.error("Error fetching remark:", error);
    }
  };

  // ─── Remark: Debounce logic ───────────────────────────────────────────────
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedRemark(remark);
    }, 100);
    return () => clearTimeout(handler);
  }, [remark]);

  // ─── Remark: Auto-save when debounced value changes ──────────────────────
  useEffect(() => {
    if (!remarkRowId) return;
    if (debouncedRemark === null || debouncedRemark === undefined) return;

    const saveRemarkAPI = async (value) => {
      setRemarkSaving(true);
      setRemarkSaved(false);
      try {
        await axios.post(
          `${globalValue}/save_remark`,
          { table: "service_log", id: remarkRowId, remark: value },
          { headers: { "x-access-token": sessionStorage.getItem("token") } }
        );
        setRemarkSaved(true);
      } catch (error) {
        console.error("Error saving remark:", error);
      } finally {
        setRemarkSaving(false);
      }
    };

    saveRemarkAPI(debouncedRemark);
  }, [debouncedRemark]);
  // ─────────────────────────────────────────────────────────────────────────


  return (
    <div>
      <div
        className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] relative  mt-16 h-[92vh] flex justify-center items-center box-border`}
      >
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        <div className="absolute right-6 bottom-8 z-50">
          <button
            onClick={() => setShowCalendar(!showCalendar)}
            className="flex items-center gap-2 bg-purple-500 p-2 text-white rounded-3xl hover:bg-blue-600 transition"
          >
            <CalendarIcon size={30} />
          </button>

          {showCalendar && (
            <div className="absolute bottom-full right-0 mt-2 shadow-lg bg-white p-2 rounded-lg z-50 w-[250px] md:w-auto">
              <Calendar
                onChange={(date) => {
                  setSelectedDate(date);
                  setShowCalendar(false);
                  console.log("date" + date);
                }}
                value={selectedDate}
              />
            </div>
          )}
        </div>
        <div className="w-[95%] md:w-[98%] h-[95%] bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">
          {swap ? (
            <>
              <div className="w-full flex justify-between text-gray-600 mb-6">
                <Head_data data=" Service Log Details" font="" size="3xl" />
              </div>

              <input
                type="text"
                placeholder="Search by Customer,Vehicle no,Brand,Model"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
              />

              <div className="grid grid-cols-1 gap-6">
                {data.length === 0 ? (
                  <div className="text-center text-gray-500 font-medium text-lg">
                    No service log to display
                  </div>
                ) : (
                  filtered
                    .filter((item) => {
                      if (!selectedDate) return true;
                      const itemDate = new Date(item.s_date);
                      const selectedLocalDate = new Date(selectedDate);
                      return (
                        itemDate.getFullYear() ===
                        selectedLocalDate.getFullYear() &&
                        itemDate.getMonth() === selectedLocalDate.getMonth() &&
                        itemDate.getDate() === selectedLocalDate.getDate()
                      );
                    })
                    .map((item, index) => {
                      const isOpen = openCard === index;
                      return (
                        <div
                          key={index}
                          className={`bg-white border-2 ${item.mode === "main"
                            ? "border-green-500"
                            : "border-blue-500"
                            } p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 relative overflow-hidden cursor-pointer`}
                          onClick={() => setOpenCard(isOpen ? null : index)}
                        >
                          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                            <div className="space-y-2 text-sm text-gray-700">
                              <div className="text-lg font-semibold text-gray-800">
                                {item.vehicle_no}
                              </div>
                              <div className="text-gray-500">
                                (
                                {item.customer_name.length > 10
                                  ? `${item.customer_name.slice(0, 10)}...`
                                  : item.customer_name}
                                )
                              </div>
                              <div>
                                <span className="font-medium">
                                  {item.brand}
                                </span>{" "}
                                - {item.model}
                                ,{" "}
                                <span className="font-medium">
                                  {item.driven_km > 0 ? " Driven KM :  " + item.driven_km + "km" : ""}
                                </span>
                              </div>
                              <div>
                                <span className="font-medium">Date:</span>{" "}
                                {new Date(item.s_date).toLocaleDateString(
                                  "en-GB"
                                )}
                              </div>
                            </div>

                            <div
                              className="flex flex-wrap justify-end gap-3 w-full md:w-auto"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                className="flex items-center gap-2 border border-gray-600 text-black px-4 py-1.5 rounded-md text-sm hover:bg-gray-700 transition"
                                onClick={() => {
                                  setShow(true);
                                  setEst_id(item.estimate_id);
                                  view_details(item.estimate_id);
                                  setSwap(false);
                                }}
                              >
                                <FaEye className="w-4 h-4" />
                                View
                              </button>

                              {item.complete_status == "2" && (
                                <button
                                  className="flex items-center gap-2 border border-blue-500 text-black px-4 py-1.5 rounded-md text-sm hover:bg-blue-600 transition"
                                  onClick={() => {
                                    fetchData();
                                    fetchData1();
                                    fetchData2();
                                    fetchDetails();
                                    setTemp_brand_modal(
                                      item["brand"] + " . " + item["model"]
                                    );
                                    setFlag("normal")
                                    setBill_type(item['bill_type']);
                                    setTotalDiscount(Number(item['total_discount']));
                                    makePdf1(item);
                                  }}
                                >
                                  <FaPrint className="w-4 h-4" />
                                  Print Receipt
                                </button>
                              )}

                              {item.complete_status == "2" && (
                                <button
                                  className="flex items-center gap-2 border border-blue-500 text-black px-4 py-1.5 rounded-md text-sm hover:bg-blue-600 transition"
                                  onClick={() => {
                                    fetchData();
                                    fetchData1();
                                    fetchData2();
                                    fetchDetails();
                                    setTemp_brand_modal(
                                      item["brand"] + " . " + item["model"]
                                    );
                                    setBill_type(item['bill_type']);
                                    setTotalDiscount(Number(item['total_discount']));
                                    setFlag("insurance")
                                    makePdf1(item);
                                  }}
                                >
                                  <FaPrint className="w-4 h-4" />
                                  Print Insurance Receipt
                                </button>
                              )}

                              {sessionStorage.getItem("position") ===
                                "superadmin" && (
                                  <button
                                    className="flex items-center gap-2 border border-red-500 text-black px-4 py-1.5 rounded-md text-sm hover:bg-red-600 transition"
                                    onClick={() =>
                                      delete_estimate(
                                        item.estimate_id,
                                        item.link,
                                        "main"
                                      )
                                    }
                                  >
                                    <FaTrash className="w-4 h-4" />
                                    Delete
                                  </button>
                                )}

                              {item.complete_status === "1" && (
                                <button
                                  className="flex items-center gap-2 border border-green-600 text-black px-4 py-1.5 rounded-md text-sm hover:bg-green-700 transition"
                                  onClick={async () => {
                                    const result = await Swal.fire({
                                      title: 'Are you sure?',
                                      text: 'This process cannot be undone. Once you proceed, it will analyze the spares taken and finalize them.',
                                      icon: 'warning',
                                      showCancelButton: true,
                                      confirmButtonText: 'Yes, proceed',
                                      cancelButtonText: 'Cancel',
                                      reverseButtons: true
                                    });

                                    if (result.isConfirmed) {
                                      setEst_id(item.estimate_id);
                                      service_complete_records(item.link);
                                    }
                                  }}
                                >
                                  <FaCheckCircle className="w-4 h-4" />
                                  Complete
                                </button>
                              )}

                              {/* ─── Remark Button ──────────────────────────────── */}
                              <button
                                className="flex items-center gap-2 border border-purple-500 text-purple-700 px-4 py-1.5 rounded-md text-sm hover:bg-purple-100 transition"
                                onClick={() => handleOpenRemark(item.estimate_id)}
                              >
                                <FaStickyNote className="w-4 h-4" />
                                Remark
                              </button>
                              {/* ──────────────────────────────────────────────── */}
                            </div>
                          </div>

                          {isOpen && (
                            <div className="mt-4 pt-4 border-t border-gray-200">
                              <div className="text-sm font-semibold text-gray-800 mb-2">
                                Additional Estimates
                              </div>
                              <button
                                className="bg-gray-600 text-white px-4 py-1.5 rounded-md text-sm hover:bg-gray-700 transition"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setAdd_show(true);
                                  add_details(item.link);
                                }}
                              >
                                Additional Estimates
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })
                )}
              </div>
            </>
          ) : (
            <>
              <Service_details
                view_data={view_data}
                view_details={view_details}
                setSwap={setSwap}
              />
            </>
          )}
        </div>
      </div>

      {/* ─── Remark Modal ────────────────────────────────────────────────────── */}
      <Modal
        show={remarkModalOpen}
        size="lg"
        popup={true}
        onClose={() => {
          setRemarkModalOpen(false);
          setRemarkRowId(null);
          setRemark("");
          setDebouncedRemark("");
          setRemarkSaved(false);
        }}
      >
        <Modal.Header className="flowbite-modal-h">
          Remark
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <div className="flex flex-col gap-3">
            <textarea
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
                setRemarkSaved(false);
              }}
              placeholder="Type your remark here... (auto-saves after 2 seconds)"
              rows={8}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 resize-none text-gray-800 text-sm transition"
            />
            <div className="flex items-center gap-2 text-sm min-h-[22px]">
              {remarkSaving && (
                <span className="text-yellow-500 flex items-center gap-1">
                  <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Saving...
                </span>
              )}
              {!remarkSaving && remarkSaved && (
                <span className="text-green-600 flex items-center gap-1">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Remark saved!
                </span>
              )}
              {!remarkSaving && !remarkSaved && remark !== "" && (
                <span className="text-gray-400 text-xs">Waiting to save...</span>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-h">
          <button
            onClick={() => {
              setRemarkModalOpen(false);
              setRemarkRowId(null);
              setRemark("");
              setDebouncedRemark("");
              setRemarkSaved(false);
            }}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* ──────────────────────────────────────────────────────────────────────── */}


      {/* ─── Receipt / Insurance Print Modal ─────────────────────────────────── */}
      <Modal
        show={isPdfFormate}
        size="6xl"
        popup={true}
        onClose={() => setIsPdfFormate(false)}
      >
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200"></Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          <div
            id="pdf-content"
            className="mx-auto bg-white p-8 text-gray-800 border border-gray-400 shadow-md max-w-3xl print:p-4 print:shadow-none"
          >
            <div className="flex items-center border-b pb-4">
              <div>
                <img src={Logo} alt="JALS Automobiles Logo" className="h-16 w-auto" />
              </div>
              <div className="flex-1 text-center">
                <h2 className="text-2xl font-bold uppercase">
                  JALS AUTOMOBILES
                </h2>

                {sessionStorage.getItem("branch") === "JBRANCH2025030" ? (
                  <>
                    <p>
                      Door No : 6/63, Jals Road, Kuppottu Vilai,
                      <br />
                      Kadamacode, Melpuram, Pacode Post - 629168
                    </p>
                    <p>Ph : 04651-264007 | Mob : 8300451644</p>
                    <p>GSTIN : 33AMEPL9265E1Z1</p>
                  </>
                ) : (
                  <>
                    <p>
                      6/31 F, Karavilagam Road, Chennithottam Junction, Vettuvanni,
                      <br />
                      Marthandam - 629162
                    </p>
                    <p>Ph: 04651-271220 | Mob: 9488495820</p>
                    <p>GSTIN: 33AMEPL9265E1Z1</p>
                  </>
                )}
              </div>

            </div>

            <div className="text-center mt-2">
              <p className="font-semibold underline text-lg">{bill_type} Bill</p>
            </div>
            <div className="flex justify-between mt-1 mb-2">
              <p>Invoice No : {pdf_insurance_data?.invoice_number}</p>
              <p>
                Date:{" "}
                <span className="font-semibold">
                  {new Date(
                    pdf_insurance_data?.estimate_date
                  ).toLocaleDateString("en-GB")}
                </span>
              </p>
            </div>
            {flag === "insurance" && <>
              <h2 className="text-lg font-bold pb-1">Insurance Details</h2>
              <table className="w-full mb-2 border border-gray-400 text-sm border-collapse">
                <tbody>
                  <tr>
                    <td className="font-semibold border px-3 pb-2 w-1/3">Insurance Company</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_company || ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">Branch</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_branch || ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">Branch Code</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.branch_code || ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">Branch Mobile</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_branch_mobile || ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">Insurance No</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_no || ""}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">GST No</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.gst_no || ""}
                    </td>
                  </tr>
                </tbody>
              </table>

              <h2 className="text-lg font-bold pb-2 mt-2">To</h2></>}
            <table className="w-full mb-3 border border-gray-400 text-sm border-collapse">
              <tbody>
                <tr>
                  <td className="font-semibold border px-3 pb-2 w-1/3">Customer Name</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.customer_name || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Vehicle No</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.vehicle_no || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Mobile No</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.mobile_no || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Brand</td>
                  <td className="border px-3 pb-2">{pdf_insurance_data?.brand || ""}</td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Model</td>
                  <td className="border px-3 pb-2">{pdf_insurance_data?.model || ""}</td>
                </tr>
                {pdf_insurance_data?.driven_km > 0 ? <tr>
                  <td className="font-semibold border px-3 pb-2">Driven KM</td>
                  <td className="border px-3 pb-2">{pdf_insurance_data?.driven_km || ""}km</td>
                </tr> : null}
              </tbody>
            </table>

            <h2 className="text-lg font-bold pb-2 mt-2">All Spares</h2>

            {(() => {
              let serial = 1;

              const toNum = (val) => {
                const n = parseFloat(val);
                return isNaN(n) ? 0 : n;
              };

              const groupedSpares = groupSparesByGst(pdf_insurance_data?.all_spares || []);

              const overallGrandTotal = Object.values(groupedSpares)
                .flat()
                .reduce((sum, s) => sum + toNum(s.quantity) * toNum(s.mrp), 0);

              if (overallGrandTotal === 0) return null;

              return (
                <>
                  {Object.entries(groupedSpares).map(([gst, spares]) => {
                    const gstRate = toNum(gst);
                    const validSpares = spares.filter(
                      (s) => toNum(s.quantity) * toNum(s.mrp) > 0
                    );

                    if (validSpares.length === 0) return null;

                    return (
                      <div key={gst} className="mb-8">
                        <h3 className="font-semibold mb-2">{gstRate}% GST Spares</h3>
                        <table className="w-full mb-3 border border-gray-400 text-sm border-collapse">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border px-3 pb-2 text-left">S.No</th>
                              <th className="border px-3 pb-2 text-left">Spare Name</th>
                              <th className="border px-3 pb-2 text-center">Quantity</th>
                              <th className="border px-3 pb-2 text-right">MRP</th>
                              <th className="border px-3 pb-2 text-right">Rate</th>
                              <th className="border px-3 pb-2 text-right">
                                CGST ({(gstRate / 2).toFixed(0)}%)
                              </th>
                              <th className="border px-3 pb-2 text-right">
                                SGST ({(gstRate / 2).toFixed(0)}%)
                              </th>
                              <th className="border px-3 pb-2 text-right">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {validSpares.map((spare, i) => {
                              const mrp = toNum(spare.mrp);
                              const gstVal = toNum(spare.gst);
                              const quantity = toNum(spare.quantity);
                              const total = quantity * mrp;

                              const rate = mrp / (1 + gstVal / 100);
                              const totalGstPerItem = mrp - rate;
                              const cgstAmount = totalGstPerItem / 2;
                              const sgstAmount = cgstAmount;

                              const currentSerial = serial;
                              serial += 1;

                              return (
                                <tr key={i}>
                                  <td className="border px-3 pb-2">{currentSerial}</td>
                                  <td className="border px-3 pb-2">{spare.spare_name || ""}</td>
                                  <td className="border px-3 pb-2 text-center">{quantity}</td>
                                  <td className="border px-3 pb-2 text-right">{mrp.toFixed(2)}</td>
                                  <td className="border px-3 pb-2 text-right">{rate.toFixed(2)}</td>
                                  <td className="border px-3 pb-2 text-right">{cgstAmount.toFixed(2)}</td>
                                  <td className="border px-3 pb-2 text-right">{sgstAmount.toFixed(2)}</td>
                                  <td className="border px-3 pb-2 text-right">{total.toFixed(2)}</td>
                                </tr>
                              );
                            })}
                            <tr>
                              <td colSpan={7} className="font-bold text-right border px-3 pb-2">
                                Total
                              </td>
                              <td className="font-bold border px-3 pb-2 text-right">
                                {validSpares
                                  .reduce((sum, s) => sum + toNum(s.quantity) * toNum(s.mrp), 0)
                                  .toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })}

                  <div className="mt-6 text-right font-bold text-lg">
                    Overall Spares Total: {overallGrandTotal.toFixed(2)}
                  </div>
                </>
              );
            })()}

            <h2 className="text-lg font-bold mb-2 border-b pb-2">Labour Charges</h2>
            <div className="mb-4">
              <table className="w-full border border-gray-400 text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-3 py-1 text-left">S.No</th>
                    <th className="border px-3 py-1 text-left">Service</th>
                    <th className="border px-3 py-1 text-right">Amount</th>
                    <th className="border px-3 py-1 text-right">GST (18%)</th>
                    <th className="border px-3 py-1 text-right">Total (Incl. GST)</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const gstRate = 18;
                    let totalGST = 0;
                    let totalAmount = 0;
                    let serial = 1;

                    const diff = parseFloat(pdf_insurance_data?.diff) || 0;

                    (pdf_insurance_data?.service_category || [])
                      .filter((cat) => (cat?.subcategories || []).length > 0)
                      .forEach((cat) => {
                        const catTotal = (cat?.subcategories || []).reduce(
                          (sum, sub) => sum + (parseFloat(sub?.amount) || 0),
                          0
                        );
                        totalAmount += catTotal;
                      });

                    const amountAfterDiff = totalAmount - diff;
                    const gstAmount = amountAfterDiff * 0.18;
                    totalGST = gstAmount;
                    const baseAmount = amountAfterDiff + totalGST;

                    const rows = [];
                    if (totalAmount > 0) {
                      rows.push(
                        <tr key="accidental" className="font-bold">
                          <td className="border px-3 py-1">{serial++}</td>
                          <td className="border px-3 py-1">Accident Repair Charges</td>
                          <td className="border px-3 py-1 text-right">{Number(amountAfterDiff).toFixed(2)}</td>
                          <td className="border px-3 py-1 text-right">{totalGST.toFixed(2)}</td>
                          <td className="border px-3 py-1 text-right">{baseAmount.toFixed(2)}</td>
                        </tr>
                      );
                    }

                    const categories = pdf_insurance_data?.service_category || [];
                    const services = pdf_insurance_data?.services || [];

                    const categoryBasedLabourServices = categories
                      .filter((cat) => (cat?.subcategories || []).length === 0)
                      .map((cat) => services.find((s) => s.service_name === cat.service_name))
                      .filter(Boolean);

                    const uncategorizedLabourServices = services.filter(
                      (s) => !categories.some((cat) => cat.service_name === s.service_name)
                    );

                    const labourOnlyServices = [
                      ...categoryBasedLabourServices,
                      ...uncategorizedLabourServices,
                    ].filter((s) => (s?.labour_charge || 0) > 0);

                    labourOnlyServices.forEach((service, idx) => {
                      rows.push(
                        <tr key={`labour-${idx}`}>
                          <td className="border px-3 py-1">{serial++}</td>
                          <td className="border px-3 py-1">{service?.service_name || "Unnamed Service"}</td>
                          <td className="border px-3 py-1 text-right">{Number(service?.labour_charge || 0).toFixed(2)}</td>
                          <td className="border px-3 py-1 text-right">{"-"}</td>
                          <td className="border px-3 py-1 text-right">{Number(service?.labour_charge || 0).toFixed(2)}</td>
                        </tr>
                      );
                    });

                    return rows;
                  })()}
                </tbody>
              </table>
            </div>

            {(() => {
              const categories = pdf_insurance_data?.service_category || [];
              const services = pdf_insurance_data?.services || [];
              const allSpares = pdf_insurance_data?.all_spares || [];
              const diff = parseFloat(pdf_insurance_data?.diff) || 0;

              const sparesTotal = allSpares.reduce(
                (sum, s) => sum + (parseFloat(s?.total) || 0),
                0
              );

              let totalAmount = 0;
              categories.forEach((cat) => {
                const catTotal = (cat?.subcategories || []).reduce(
                  (sum, sub) => sum + (parseFloat(sub?.amount) || 0),
                  0
                );
                totalAmount += catTotal;
              });

              const amountAfterDiff = totalAmount - diff;
              const categoryGST = amountAfterDiff * 0.18;
              const categoryTotal = amountAfterDiff + categoryGST;

              const labourTotal = services.reduce(
                (sum, service) => sum + (parseFloat(service?.labour_charge) || 0),
                0
              );

              const grandTotal = (sparesTotal + categoryTotal + labourTotal).toFixed(2);

              return (
                <>
                  <div className="page-break"></div>
                  {(() => {
                    const totalDiscount = parseFloat(totalDiscount1) || 0;
                    const finalGrandTotal = (grandTotal - totalDiscount).toFixed(2);

                    return (
                      <>
                        <div className="page-break"></div>

                        <div className="mt-4 flex justify-end">
                          <table className="w-1/2 border border-gray-400 text-sm border-collapse">
                            <tbody>
                              <tr>
                                <td className="border px-3 py-2 font-semibold text-right">
                                  Grand Total
                                </td>
                                <td className="border px-3 py-2 text-right">
                                  {Number(grandTotal).toFixed(2)}
                                </td>
                              </tr>

                              {totalDiscount > 0 && (
                                <>
                                  <tr>
                                    <td className="border px-3 py-2 font-semibold text-right">
                                      Discount
                                    </td>
                                    <td className="border px-3 py-2 text-right">
                                      - {totalDiscount.toFixed(2)}
                                    </td>
                                  </tr>

                                  <tr className="bg-gray-100 font-bold">
                                    <td className="border px-3 py-2 text-right">
                                      Final Grand Total
                                    </td>
                                    <td className="border px-3 py-2 text-right">
                                      {finalGrandTotal}
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* ─── Print the fetched remark at the bottom of the receipt ─── */}
                        {pdfRemark && pdfRemark.trim() !== "" && (
                          <div
                            className="mt-4 p-3 border border-gray-300 rounded text-sm text-gray-700"
                            style={{ wordBreak: "break-word", whiteSpace: "pre-wrap", width: "100%" }}
                          >
                            <span className="font-semibold">Note : </span>
                            {pdfRemark}
                          </div>
                        )}
                        {/* ────────────────────────────────────────────────────────────── */}
                      </>
                    );
                  })()}
                </>
              );
            })()}

          </div>
          <style>
            {`
                      .page-break-inside-avoid {
                        page-break-inside: avoid;
                      }
                      table {
                        page-break-inside: auto;
                      }
                      tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                      }  
                  `}
          </style>
        </Modal.Body>

        <Modal.Footer className="flowbite-modal-b">
          <button
            onClick={() => handlePrint1()}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Print
          </button>
        </Modal.Footer>
      </Modal>
      {/* ──────────────────────────────────────────────────────────────────────── */}

      {add_show && (
        <Modal
          show={add_show}
          size={add_data.length === 1 ? "lg" : "4xl"}
          popup={true}
          onClose={() => setAdd_show(false)}
        >
          <Modal.Header className="flowbite-modal-h">Customer</Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div
              className={`grid ${add_data.length === 1
                ? "grid-cols-1"
                : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-2"
                } gap-6`}
            >
              {add_data.map((item, index) => (
                <div
                  key={index}
                  className={`bg-white border-2 ${item["mode"] === "main"
                    ? "border-green-500"
                    : "border-blue-500"
                    } p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 ease-in-out relative`}
                >
                  <div className="text-xl font-semibold text-gray-800">
                    <span className="text-gray-500">
                      {item["vehicle_no"]} ({item["customer_name"]})
                    </span>
                  </div>

                  <div className="mt-3 text-md text-gray-600">
                    {item["brand"]}-{item["model"]}
                  </div>

                  <div className="mt-2 text-sm text-gray-500">
                    <span className="font-medium text-gray-700">Date:</span>{" "}
                    {new Date(item["date"]).toLocaleDateString("en-GB")}
                  </div>

                  <div className="absolute bottom-2 right-4 flex flex-col gap-3">
                    <button
                      className="bg-blue-500 text-white p-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none"
                      onClick={() => {
                        setShow(true);
                        setEst_id(item["estimate_id"]);
                        view_details(item["estimate_id"]);
                        setSwap(false);
                        setAdd_show(false);
                      }}
                    >
                      <FaEye />
                    </button>
                    <button
                      className="bg-blue-500 text-white p-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none"
                      onClick={() => {
                        fetchData();
                        fetchData2();
                        fetchData1();
                        fetchDetails();
                        makePdf(item);
                      }}
                    >
                      <FaPrint />
                    </button>

                    {sessionStorage.getItem("position") === "superadmin" ? (
                      <button
                        className="bg-red-500 text-white p-2 rounded-md shadow-md hover:bg-red-600 focus:outline-none"
                        onClick={() =>
                          delete_estimate(
                            item["estimate_id"],
                            item["link"],
                            "sub"
                          )
                        }
                      >
                        <FaTrash />
                      </button>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {modalOpen && (
        <Modal
          show={modalOpen}
          size="md"
          popup={true}
          onClose={() => setModalOpen(false)}
        >
          <Modal.Header className="flowbite-modal-h">Customer</Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="space-y-6">
              <div>
                <Label value="Select Customer" />
                <Select
                  options={customers}
                  onChange={(selected) => setSelectedCustomer(selected)}
                  isSearchable
                  placeholder="Search for a customer..."
                  className="mt-2"
                  color="white"
                />
              </div>
              <div>
                <Label value="Select Date" />
                <TextInput
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="mt-2"
                  color="white"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <button
              onClick={handleSave}
              className="bg-green-500 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
            <button
              onClick={() => setModalOpen(false)}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded ml-2"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      )}

    </div>
  );
};

export default Service_log;